import { UnderlineNav as UnderlineNav$1 } from './UnderlineNav.js';
import { UnderlineNavItem } from './UnderlineNavItem.js';

const UnderlineNav = Object.assign(UnderlineNav$1, {
  Item: UnderlineNavItem
});

export { UnderlineNav };
